import React, { useState } from "react";
import { useForm } from "react-hook-form";
import api from "../services/api.js";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { FaEdit } from "react-icons/fa";
import { FaTrash } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import DeleteButton from "./DeleteButton.jsx";

const AddRolesUsers = ({ users, addUser, updateUser, removeUser }) => {
  const [successMessage, setSuccessMessage] = useState("");
  const [editingUserId, setIsEditingUserId] = useState(null);
  const [editedUser, setEditedUser] = useState({});
  const [editErrorMessage, setEditErrorMessage] = useState("");

  const addUserSchema = z.object({
    name: z.string().min(1, "O nome é obrigatório"),
    email: z.string().email(),
    password: z.string().min(1, "A senha é obrigatória"),
    accessType: z.enum(["USER", "ADMIN", "AGENT"]),
  });

  const editUserSchema = z.object({
    name: z.string().min(1, "O nome é obrigatório"),
    email: z.string().email(),
    password: z.string().optional(),
    accessType: z.enum(["USER", "ADMIN", "AGENT"]),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ resolver: zodResolver(addUserSchema) });

  const onFormSubmit = async (values) => {
    try {
      const response = await api.post(`/register`, values);
      addUser(response.data);
      reset();
    } catch (error) {
      console.error("Erro ao criar usuário: ", error);
    }
  };

  const fieldLabels = {
    name: "Usuário",
    email: "Email",
    password: "Senha",
    accessType: "Permissão",
  };

  const handleEditClick = (user) => {
    setIsEditingUserId(user.id);
    setEditedUser(user);
    setEditErrorMessage("");
  };

  const handleSaveClick = async (id) => {
    try {
      const { createdAt, updatedAt, ...userData } = editedUser;

      const validation = editUserSchema.safeParse(userData);

      if (!validation.success) {
        const formattedErrors = validation.error.format();
        const errorFields = Object.keys(formattedErrors)
          .map((key, index) => {
            if (key !== "_errors") {
              return (
                fieldLabels[key] +
                (index < Object.keys(formattedErrors).length - 1 ? "," : "")
              );
            }
            return null;
          })
          .filter(Boolean)
          .join("\n");

        console.log("lala");
        const isMultipleFields = errorFields.split(",").length > 1;
        setEditErrorMessage(
          `Por favor, revise o valor ${
            isMultipleFields ? "dos campos" : "do campo"
          }: ${errorFields}`
        );
        return;
      }

      await api.put(`/users/${id}`, userData);

      updateUser(id, userData);
      setEditErrorMessage("");
      setIsEditingUserId(null);
    } catch (error) {
      console.error("Erro inesperado:", error);
      setEditErrorMessage("Ocorreu um erro ao salvar. Tente novamente.");
    }
  };

  const handleDeleteUser = async (id) => {
    try {
      await api.delete(`/users/${id}`);
      removeUser(id);
    } catch (error) {
      console.error("erro ao excluir usuário: ", error);
      alert("Erro ao excluir usuário");
    }
  };

  const handleInputChange = (e, field) => {
    setEditedUser({ ...editedUser, [field]: e.target.value });
  };

  return (
    <div className="bg-[#F2F2F2] rounded-md px-4 pb-4 pt-8 mt-4 text-boldGray opacity-90 ">
      <table className="w-full border-gray-300">
        <thead>
          <tr className="h-16 flex ">
            <th className="flex-1 text-center">USUÁRIO</th>
            <th className="flex-1 text-center">EMAIL</th>
            <th className="flex-1 text-center">SENHA</th>
            <th className="flex-1 text-center">PERMISSÃO</th>
            <th className="flex-1 text-center"></th>
          </tr>
        </thead>
        <tbody>
          <div className="overflow-y-auto h-[200px] custom-scrollbar">
            <div className="mr-4">
              {users.map((user) => {
                return (
                  <tr
                    className="h-16 flex rounded-md relative bg-gray-200 mt-4  items-center justify-center"
                    key={user.id}
                  >
                    {editingUserId === user.id ? (
                      <>
                        {editErrorMessage && (
                          <div className="absolute -top-4">
                            <p className="text-red-500  text-sm">
                              {editErrorMessage}
                            </p>
                          </div>
                        )}
                        <td className="flex-1 text-center">
                          <input
                            value={editedUser.name || ""}
                            onChange={(e) => handleInputChange(e, "name")}
                            className="w-full h-full text-center border border-gray-300 rounded p-2 box-border"
                          />
                        </td>
                        <td className="flex-1 text-center">
                          <input
                            value={editedUser.email || ""}
                            onChange={(e) => handleInputChange(e, "email")}
                            className="w-full h-full text-center border border-gray-300 rounded p-2 box-border"
                          />
                        </td>
                        <td className="flex-1 text-center">
                          <input
                            value={editedUser.password || ""}
                            onChange={(e) => handleInputChange(e, "password")}
                            type="text"
                            className="w-full h-full text-center border border-gray-300 rounded p-2 box-border"
                          />
                        </td>
                        <td className="flex-1 text-center">
                          <select
                            value={editedUser.accessType || ""}
                            onChange={(e) => handleInputChange(e, "accessType")}
                            type="number"
                            className="w-full h-full text-center border border-gray-300 rounded p-2 box-border"
                          >
                            <option value="USER">USUÁRIO</option>
                            <option value="ADMIN">ADMINISTRADOR</option>
                            <option value="AGENT">AGENTE</option>
                          </select>
                        </td>
                        <td className="flex-1/2 text-center px-4">
                          <div className="flex gap-x-2">
                            <button
                              onClick={() => handleSaveClick(user.id)}
                              className="bg-green-500 text-white px-2 py-1 rounded"
                            >
                              Salvar
                            </button>
                            <button
                              className="text-2xl"
                              onClick={() => setIsEditingUserId(null)}
                            >
                              <IoMdClose />
                            </button>
                          </div>
                        </td>
                      </>
                    ) : (
                      <>
                        {" "}
                        <td className="flex-1 text-center">{user.name}</td>
                        <td className="flex-1 text-center">{user.email}</td>
                        <td className="flex-1 text-center">{user.password}</td>
                        <td className="flex-1 text-center">
                          {user.accessType}
                        </td>
                        <td className="flex-1 text-center">
                          <div className="flex gap-x-8 w-full justify-end pr-4">
                            <button onClick={() => handleEditClick(user)}>
                              <FaEdit />
                            </button>
                            <DeleteButton
                              onConfirm={() => handleDeleteUser(user.id)}
                            />
                          </div>
                        </td>
                      </>
                    )}
                  </tr>
                );
              })}
            </div>
          </div>
        </tbody>
      </table>

      <form onSubmit={handleSubmit(onFormSubmit)} className="w-full flex mt-4">
        <input
          placeholder="Usuário"
          className="w-full py-2 px-4 text-center"
          {...register("name")}
        />

        <input
          placeholder="Email"
          className="w-full py-2 px-4 text-center"
          {...register("email")}
        />

        <input
          placeholder="Senha"
          className="w-full py-2 px-4 text-center"
          {...register("password")}
        />

        <select
          className="w-full py-2 px-4 text-center"
          {...register("accessType")}
        >
          <option value="USER">USUÁRIO</option>
          <option value="ADMIN">ADMINISTRADOR</option>
          <option value="AGENT">AGENTE</option>
        </select>

        <button
          className="w-full py-2 px-4 bg-orange-500 text-white hover:bg-orange-600"
          type="submit"
        >
          +
        </button>
      </form>
      {Object.keys(errors).length > 0 && (
        <p className="text-red-500 mt-4">
          Por favor, verifique os dados e tente novamente.
        </p>
      )}

      {/* {sucessMessage && <p className="mt-2">{sucessMessage}</p>} */}
    </div>
  );
};

export default AddRolesUsers;
